import { onDocumentReady } from '../utils/events';

onDocumentReady(() => {
  const faqSections = document.querySelectorAll('.faq');

  faqSections.forEach((section) => {
    const toggles = section.querySelectorAll('.faq__item-toggle');

    toggles.forEach((toggle) => {
      toggle.addEventListener('change', () => {
        if (!toggle.checked) {
          return;
        }

        toggles.forEach((otherToggle) => {
          if (otherToggle !== toggle) {
            otherToggle.checked = false;
          }
        });
      });
    });
  });
});
